import { render, staticRenderFns } from "./ArtistSingle.vue?vue&type=template&id=2caabef4&scoped=true&"
import script from "./ArtistSingle.vue?vue&type=script&lang=js&"
export * from "./ArtistSingle.vue?vue&type=script&lang=js&"
import style0 from "./ArtistSingle.vue?vue&type=style&index=0&id=2caabef4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caabef4",
  null
  
)

export default component.exports